import LightLayout from '../../../../../shared/Layouts/LightLayout'
import taskSandboxCss from '../taskSandbox.module.css'
import css from './fifthTaskSandbox.module.css'
import sandboxCss from '../taskSandbox.module.css'
import { memo, useState } from 'react'
import TextInput from '../../../../../shared/Inputs/TextInput'
import CreateImageOptionModal from '../../CreateImageOptionModal'
import { IDraftImage, IImage, ITask } from '../../../../../types/tasks.types'
import { useRecoilValue } from 'recoil'
import sandboxAtom from '../../../sandbox.atom'
import { ReactComponent as RemoveIcon } from '../../../../../asserts/icons/xmark.svg'

interface IProps {
  onDraftTaskChange: <T extends keyof ITask>(value: ITask[T], key: T) => void
}

const FifthTaskSandbox = (props: IProps) => {
  const { draftTask } = useRecoilValue(sandboxAtom)
  const [open, setOpen] = useState(false)

  const renderOptions = () => {
    return draftTask.images.map((option, index) => (
      <ImageOption option={option} key={option.id ?? index} index={index} onDelete={handleOptionDelete} />
    ))
  }

  const handleOptionDelete = (index: number) => {
    props.onDraftTaskChange(
      [...draftTask.images.slice(0, index), ...draftTask.images.slice(index + 1)] as any,
      'images'
    )
  }

  const handleCreate = (option: IDraftImage) => {
    props.onDraftTaskChange([...(draftTask.images as IDraftImage[]), option], 'images')
    setOpen(false)
  }

  return (
    <div className={taskSandboxCss.wrapper}>
      {open && <CreateImageOptionModal onClose={() => setOpen(false)} onCreate={handleCreate} />}
      <LightLayout>
        <div className={css.wrapper}>
          <div className={css.imageUpload}>
            <TextInput
              value={draftTask.wordToMatch?.text ?? ''}
              name="wordToMatch"
              onChange={(value) => props.onDraftTaskChange({ text: value, rightAnswer: false }, 'wordToMatch')}
              inscription="Слово"
            />
          </div>
          <div className={css.options}>
            {renderOptions()}
            <div className={sandboxCss.addOption} onClick={() => setOpen(true)}>
              Добавить карточку
            </div>
          </div>
        </div>
      </LightLayout>
    </div>
  )
}

const ImageOption = memo(
  ({ option, index, onDelete }: { option: IDraftImage | IImage; onDelete: (index: number) => void; index: number }) => {
    let url
    if ('imageFile' in option) {
      url = URL.createObjectURL(option.imageFile)
    } else {
      url = option.file
    }

    return (
      <div
        className={css.imageOption}
        style={{ backgroundImage: `url(${url})` }}
        data-rightanswer={option.rightAnswer}
        key={url}
      >
        <RemoveIcon onClick={() => onDelete(index)} className={css.cancel} />
      </div>
    )
  }
)

export default FifthTaskSandbox
